import { ReactElement } from 'react';
import { NEW_NON_EMPLOYEE_KEYS } from 'pages/NewNonEmployee/_const';
import CustomCheckbox from '../base/CustomCheckbox';

/**
 * Prompt user for input: Third-Party organization acknowledgement
 * @returns {ReactElement} checkbox asking user to ack
 */
const ThirdPartyAcknowledgement = () => {
	return (
		<CustomCheckbox
			name={NEW_NON_EMPLOYEE_KEYS.ACKNOWLEDGEMENT}
			label='I acknowledge that (1) I am authorized to request computer accounts/permissions for this individual and (2) this individual requires accounts/permissions to these computer systems in order perform their assigned duties at UPMC. As the sponsor of this account, I confirm that no patient information or confidential information will be sent via the non-UPMC email account provided for the requestee while in their role in accordance with UPMC Confidential Information (HS-HR0736) and Electronic Mail, Messaging and Texting (HS-IS0147) policies.'
			required
		/>
	);
};
export default ThirdPartyAcknowledgement;
